import { render } from "./linkAccountResponse.vue?vue&type=template&id=6e037d17&ts=true"
import script from "./linkAccountResponse.vue?vue&type=script&lang=ts"
export * from "./linkAccountResponse.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__